import { useState, useEffect, useMemo } from 'react';

export const useSlider = (itemCount, itemsPerView = 3) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [cardWidth, setCardWidth] = useState(400);
  const [isPaused, setIsPaused] = useState(false);

  const totalCardWidth = useMemo(() => cardWidth + 30, [cardWidth]);

  // Дублируем карточки для бесконечной прокрутки: последнюю в начало, первые в конец
  const duplicatedProductIndices = useMemo(() => {
    return [itemCount - 1, ...Array.from({ length: itemCount }, (_, i) => i), 0];
  }, [itemCount]);

  const totalSlides = itemCount + 2; // Оригинальные + 2 дубликата

  useEffect(() => {
    const updateCardWidth = () => {
      if (window.innerWidth < 768) {
        setCardWidth(300);
      } else if (window.innerWidth < 1024) {
        setCardWidth(350);
      } else {
        setCardWidth(400);
      }
    };

    updateCardWidth();
    window.addEventListener('resize', updateCardWidth);
    return () => window.removeEventListener('resize', updateCardWidth);
  }, []);

  const translateX = useMemo(() => {
    return -currentIndex * totalCardWidth;
  }, [currentIndex, totalCardWidth]);

  const nextSlide = () => {
    setCurrentIndex((prev) => {
      const next = prev + 1;
      if (next >= totalSlides - 1) {
        setTimeout(() => setCurrentIndex(1), 0);
        return totalSlides - 1;
      }
      return next;
    });
  };

  const prevSlide = () => {
    setCurrentIndex((prev) => {
      const prevIdx = prev - 1;
      if (prevIdx <= 0) {
        setTimeout(() => setCurrentIndex(itemCount), 0);
        return 0;
      }
      return prevIdx;
    });
  };

  const pauseAutoPlay = () => setIsPaused(true);
  const resumeAutoPlay = () => setIsPaused(false);

  // Автоматическое перелистывание
  useEffect(() => {
    if (isPaused) return;

    const interval = setInterval(() => {
      nextSlide();
    }, 3000);

    return () => clearInterval(interval);
  }, [isPaused, currentIndex]);

  const handleMouseDown = () => setIsPaused(true);
  const handleMouseUp = () => setIsPaused(false);
  const handleTouchStart = () => setIsPaused(true);
  const handleTouchEnd = () => setIsPaused(false);

  return {
    currentIndex,
    translateX,
    duplicatedProductIndices,
    nextSlide,
    prevSlide,
    pauseAutoPlay,
    resumeAutoPlay,
    handleMouseDown,
    handleMouseUp,
    handleTouchStart,
    handleTouchEnd,
  };
};
